import React from 'react';
import { background } from 'styled-system';
import { getColorFromStr } from '../WeekEvents';
import styled from 'styled-components';
import { Flex } from 'rebass';
import Text from '../../../Text';
import uniq from 'lodash/uniq';

const Legend = styled.div`
  ${background}
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;

const CalendarCitiesLegend = ({ events, ...props }) => {
  const states = uniq(
    events.filter(e => e.country === 'United States').map(event => event.state),
  );
  const countries = uniq(
    events
      .filter(e => e.country !== 'United States')
      .map(event => event.country),
  );
  const locations = [...states, ...countries];
  return (
    <Flex flexWrap="wrap" m={-2} {...props}>
      {locations.map(location => (
        <Flex alignItems="center" p={2} key={`locationLegend-${location}`}>
          <Legend
            background={`linear-gradient(90deg, ${getColorFromStr(
              location,
            )} 0%, ${getColorFromStr(location)} 50%, ${getColorFromStr(
              location,
              undefined,
              85,
            )} 50%)`}
          />
          <Text ml={1}>{location}</Text>
        </Flex>
      ))}
    </Flex>
  );
};

CalendarCitiesLegend.propTypes = {};

export default CalendarCitiesLegend;
